<template>
  <div v-bind="$attrs">
    <template v-if="compact">
      <router-link
        v-if="to"
        :to="to"
      >
        <img
          :src="compactLogoSrc"
          alt="SION"
          data-sentry-unblock
          class="w-8"
        />
      </router-link>
      <img
        v-else
        :src="compactLogoSrc"
        alt="SION"
        class="w-8"
      />
    </template>
    <template v-else>
      <router-link
        v-if="to"
        :to="to"
      >
        <img
          :src="logoSrc"
          alt="SION"
          data-sentry-unblock
          class="w-22.5"
        />
      </router-link>
      <img
        v-else
        :src="logoSrc"
        alt="SION"
        data-sentry-unblock
        class="w-22.5"
      />
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { SionUserTypes } from '@/constants/sion.js';

const props = defineProps({
  to: {
    type: [String, Object],
    default: undefined,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  variant: {
    type: String,
    default: SionUserTypes.SUPPLIER,
    validator: (val) => Object.keys(SionUserTypes).includes(val),
  },
});

const logoSrc = computed(() => {
  const sources = {
    [SionUserTypes.SUPPLIER]: '/images/logo.svg',
    [SionUserTypes.AGENCY]: '/images/logo-agency.svg',
  };
  return sources[props.variant];
});

const compactLogoSrc = computed(() => {
  const sources = {
    [SionUserTypes.SUPPLIER]: '/images/logo-compact.svg',
    [SionUserTypes.AGENCY]: '/images/logo-agency-compact.svg',
  };
  return sources[props.variant];
});
</script>
